var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDefaultCardIcon(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2 5h17.6V3H3.2v2zm17.6 0c.627 0 1.2.54 1.2 1.286h2C24 4.507 22.603 3 20.8 3v2zM22 6.286v11.428h2V6.286h-2zm0 11.428c0 .747-.573 1.286-1.2 1.286v2c1.803 0 3.2-1.507 3.2-3.286h-2zM20.8 19H3.2v2h17.6v-2zM3.2 19c-.627 0-1.2-.54-1.2-1.286H0C0 19.493 1.397 21 3.2 21v-2zM2 17.714V6.286H0v11.428h2zM2 6.286C2 5.539 2.573 5 3.2 5V3C1.397 3 0 4.507 0 6.286h2zM0 10h24V8H0v2z",
    fill: "#656873"
  })));
}

export default SvgDefaultCardIcon;